<template>
  <default-layout class-list="grid">
    <back-button/>
    <v-container v-if="loading" class="d-flex justify-center align-center">
      <v-progress-circular :size="70" color="primary" indeterminate/>
    </v-container>
    <marzipano v-else/>
  </default-layout>
</template>

<script>
import store from '@/store';
import { mapActions, mapGetters } from 'vuex';
import DefaultLayout from '@/layouts/Default.vue';
import Marzipano from '@/components/marzipano/Marzipano.vue';
import BackButton from '@/components/BackButton.vue';

export default {
  name: 'NativePanorama',
  components: { BackButton, DefaultLayout, Marzipano },
  props: {
    unitTypeId: {
      type: Number,
      required: true,
    },
    floor: {
      type: Number,
      default: undefined,
    },
    hotspotId: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters('nativePanorama', ['data']),
  },
  created() {
    // Hide POI toggle on native panorama views (no POIs here)
    store.dispatch('exteriors/isShownTogglePOI', false);

    this.loading = true;
    this.load(this.unitTypeId)
      .then(() => this.switchHotspot({ id: this.hotspotId }))
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    ...mapActions('nativePanorama', ['load', 'switchHotspot']),
  },
};
</script>

